export default "__VITE_ASSET__DdrlDQo1__"